import React from "react";
import Img from "../../Assets/Images/Birth_Image1.jpeg";
import './howtoschedule.css';
import HowToScheduleBlock from "../../Components/HowToScheduleBlock/HowToScheduleBlock";
import Sponsors from "../../Components/Home/Sponsers/Sponsers";
import StaticPageHeaders from "../../Components/StaticPageHeaders";
import SEO from "../../Components/SEO";


const SuccessStoriesBlock = [
    {
        image: "https://www.youtube.com/embed/Zc7TVktVSXo"
    }
]



const HowToSchedule = () => {
    return (
        <>
        <SEO
            title="How to schedule - Shootin School Basketball"
            description=""
            url="https://shootinschool.com/how-to-schedule/"
        />
        <StaticPageHeaders title="How To Schedule" />

            <div className="howtoschedule-container">
                <div className="howtoschedule-sss-layout">
                   <div className="howtoschedule-sss-layout-header">
                        <span>Everything you need to know while scheduling your next session</span>
                    </div>
                    <div className="sss-grid">
                        {SuccessStoriesBlock.map((successstory, i) => (
                            <HowToScheduleBlock
                                key={i}
                                image={successstory.image}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};
export default HowToSchedule